import React from 'react';
import { baseURL } from 'config/api.js';
import { useState, useEffect } from 'react';
import './purchaseOrdersEdit.css';
import { useParams } from "react-router-dom";
import { AuthContext } from '../../context/AuthContext.jsx';
import { useContext } from 'react';
import Layout from 'components/global/Layout';
import Loader from 'components/global/Loader';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

export const PurchaseOrdersEdit = () => {
  const [message, setMessage] = useState(null);
  const [po, setPO] = useState(null);
  const [employees, setEmployees] = useState(null);
  const [grossTotal, setGrossTotal] = useState("0.00");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { userData } = useContext(AuthContext);
  const params = useParams();

  async function fetchData() {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };

    let getPOURL = baseURL + "/purchaseorders/" + params.id;
    const getPOResponse = await fetch(getPOURL, {
      method: "GET",
      headers: headers
    });
    const getPOJSONData = await getPOResponse.json();
    if (!getPOResponse.ok) {
      toast.error(getPOJSONData.data.message);
      setMessage(getPOJSONData.data.message);
      setIsLoadingError(true);
      setIsLoading(false);
      return; //early return
    }
    const po = getPOJSONData.data.doc;

    let employees = null;
    if (userData.doc.isSuperAdmin || userData.doc.isAdmin) {
      let getEmployeesURL = baseURL + "/employees/";
      const getEmployeesResponse = await fetch(getEmployeesURL, {
        method: "GET",
        headers: headers
      });
      const getEmployeesJSONData = await getEmployeesResponse.json();
      if (!getEmployeesResponse.ok) {
        toast.error(getEmployeesJSONData.data.message);
        setMessage(getEmployeesJSONData.data.message);
        setIsLoadingError(true);
        setIsLoading(false);
        return; //early return
      }
      employees = getEmployeesJSONData.data.docs;
    }

    setEmployees(employees);
    setPO(po);
    setGrossTotal(po.purchaseOrderGrossAmount);
    setIsLoading(false);
  }

  async function sendAPIRequest(payload) {
    let url = baseURL + "/purchaseorders/update/" + params.id;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + userData.token
    };
    const response = await fetch(url, {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(payload),
    });
    const jsonData = await response.json();
    if (jsonData.success) {
      toast.success(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.resolve("success");
    }
    else {
      toast.error(jsonData.data.message);
      setMessage(jsonData.data.message);
      return Promise.reject("failure");
    }
  }

  async function handleEditPurchaseOrderForm(event) {
    event.preventDefault();
    let errors = [];
    let editPurchaseOrderForm = event.target;

    setIsSubmitting(true);

    let purchaseOrderCreator = editPurchaseOrderForm.elements.namedItem("purchaseOrderCreator");
    if (purchaseOrderCreator) {
      if (!purchaseOrderCreator.value) {
        errors.push("Purchase order creator is required");
      }
      else {
        purchaseOrderCreator = purchaseOrderCreator.value;
      }
    }

    let materials = [];

    let tbody = event.target.querySelector(`tbody`);
    const currentNumberOfItems = tbody.children.length;
    for (let i = 1; i <= currentNumberOfItems; i++) {
      let row = tbody.querySelector(`tr#itemCount` + i);
      const stockItemObjectId = row.getAttribute(`data-stockid`);
      const stockItemName = row.querySelector(`#nameItemCount${i}`).childNodes[0].nodeValue;
      const demandQuantity = parseFloat(row.querySelector(`#demandQuantityItemCount${i}`).childNodes[0].nodeValue);
      const quoteQuantity = parseFloat(row.querySelector(`#quoteQuantityItemCount${i}`).childNodes[0].nodeValue);
      let rate = parseFloat(row.querySelector(`#rateItemCount${i}`).childNodes[0].nodeValue);
      let orderedQuantity = parseFloat(row.querySelector(`input[name="orderedQuantityItemCount${i}"`).value);

      if (isNaN(demandQuantity)) {
        errors.push("Demand quantity is not a number");
      }
      if (isNaN(quoteQuantity)) {
        errors.push("Quote quantity is not a number");
      }
      if (isNaN(rate)) {
        errors.push("Quoted rate is not a number");
      }
      if (isNaN(orderedQuantity)) {
        errors.push(`${stockItemName} ordered quantity is not a number`);
      }

      materials.push({
        stockItemObjectId,
        stockItemName,
        demandQuantity,
        quoteQuantity,
        rate,
        orderedQuantity,
      });

    }

    let mdConsent = editPurchaseOrderForm.elements.namedItem("mdConsent");
    let mdComment = editPurchaseOrderForm.elements.namedItem("mdComment");
    if (mdConsent) {
      if (mdConsent.checked) {
        mdConsent = "accept"
      }
      else {
        mdConsent = "pending"
      }
      mdComment = mdComment.value;
    }

    let cooConsent = editPurchaseOrderForm.elements.namedItem("cooConsent");
    let cooComment = editPurchaseOrderForm.elements.namedItem("cooComment");
    if (cooConsent) {
      if (cooConsent.checked) {
        cooConsent = "accept"
      }
      else {
        cooConsent = "pending"
      }
      cooComment = cooComment.value;
    }

    let pmConsent = editPurchaseOrderForm.elements.namedItem("pmConsent");
    let pmComment = editPurchaseOrderForm.elements.namedItem("pmComment");
    if (pmConsent) {
      if (pmConsent.checked) {
        pmConsent = "accept"
      }
      else {
        pmConsent = "pending"
      }
      pmComment = pmComment.value;
    }

    let qsConsent = editPurchaseOrderForm.elements.namedItem("qsConsent");
    let qsComment = editPurchaseOrderForm.elements.namedItem("qsComment");
    if (qsConsent) {
      if (qsConsent.checked) {
        qsConsent = "accept"
      }
      else {
        qsConsent = "pending"
      }
      qsComment = qsComment.value;
    }

    if (errors.length > 0) {
      let errorMessage = errors.join(', ');
      toast.error(errorMessage);
      setMessage(errorMessage);
      setIsSubmitting(false);
    }
    else {
      let payload = {
        vendorID: po.vendorID._id,
        quotationID: po.quotationID._id,
        projectID: po.quotationID.projectID._id,
        materials,
        purchaseOrderGrossAmount: parseFloat(grossTotal),
        cooConsent: cooConsent ? cooConsent : undefined,
        mdConsent: mdConsent ? mdConsent : undefined,
        pmConsent: pmConsent ? pmConsent : undefined,
        qsConsent: qsConsent ? qsConsent : undefined,
        cooComment: cooComment ? cooComment : undefined,
        mdComment: mdComment ? mdComment : undefined,
        pmComment: pmComment ? pmComment : undefined,
        qsComment: qsComment ? qsComment : undefined,
      };
      try {
        await sendAPIRequest(payload);
        setIsSubmitting(false);
      }
      catch (error) {
        setIsSubmitting(false);
      }
    }
  }

  function handleQuantityChange(e) {
    let td = e.target.parentElement;
    let tbody = td.parentElement.parentElement;
    let sum = 0.0;
    const currentNumberOfItems = tbody.children.length;
    for (let i = 1; i <= currentNumberOfItems; i++) {
      let row = tbody.querySelector(`tr#itemCount` + i);
      let rate = parseFloat(row.querySelector(`#rateItemCount${i}`).childNodes[0].nodeValue);
      let orderedQuantity = parseFloat(row.querySelector(`input[name="orderedQuantityItemCount${i}"`).value);
      if (isNaN(rate)) {
        rate = 0.0;
      }
      if (isNaN(orderedQuantity)) {
        orderedQuantity = 0.0;
      }
      sum = sum + (orderedQuantity * rate);
    }
    if (isNaN(sum)) {
      setGrossTotal(0);
    }
    else {
      setGrossTotal(sum.toFixed(2));
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  if (isLoading || (!isLoading && isLoadingError)) {
    return (
      <Layout>
        <div className='space-y-5'>
          <div className='flex flex-row justify-between items-center px-3'>
            <h2 className='text-2xl text-primary font-bold'>Edit a purchase order</h2>
          </div>
          <div className='flex flex-row justify-start'>
            <div>
              {message && message}
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </Layout>
    );
  }

  let employeesList = [];
  let poItemsList = [];

  if (employees && employees.length !== 0) {
    employeesList = employees.map((employee, index) => {
      return (
        <option key={employee._id} value={employee._id}>{employee.full_name} {employee.email}</option>
      );
    });
  }

  if (po && po.materials.length !== 0) {
    let count = 0;
    poItemsList = po.materials.map((material, index) => {
      count++;
      return (
        <tr onChange={handleQuantityChange} key={material._id} id={`itemCount` + count} data-stockid={material.stockItemObjectId}>
          <td id={`nameItemCount` + count}>{`${material.stockItemName}`}</td>
          <td id={`demandQuantityItemCount` + count}>{`${material.demandQuantity}`}</td>
          <td id={`quoteQuantityItemCount` + count}>{`${material.quoteQuantity}`}</td>
          <td id={`rateItemCount` + count}>{`${material.rate}`}</td>
          <td><input defaultValue={material.orderedQuantity} name={`orderedQuantityItemCount` + count} type="number" min="0" step="0.01" className='border border-[#8E8EA1] text-gray-900 w-full py-1 rounded-[40px] px-3 outline-none text-sm' /></td>
        </tr>
      );
    })
  }

  console.log("Before PurchaseOrdersEdit() rendering");

  return (
    <Layout>
      <div className='w-full space-y-5'>
        <div className='flex flex-row justify-between items-center px-3'>
          <h2 className='text-2xl text-primary font-bold'>Edit a purchase order</h2>
        </div>
        <div className='flex flex-row justify-start'>
          <div>
            {message && message}
          </div>
        </div>
        <div className='overflow-x-auto rounded-lg border border-primary p-8 text-gray-900'>
          <form id="editPurchaseOrderForm" onSubmit={handleEditPurchaseOrderForm} className="space-y-5">

            <div className='flex flex-col md:flex-row md:flex-wrap gap-y-3 my-3'>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className="text-base font-normal text-left">Quotation ID</label>
                <div className="w-full md:w-11/12 py-2 text-sm">{po.quotationID.quotationID}</div>
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className="text-base font-normal text-left">Project Name</label>
                <div className="w-full md:w-11/12 py-2 text-sm">{po.quotationID.projectID.projectName}</div>
              </div>

              <div className='flex flex-col space-y-3 w-full md:w-1/3'>
                <label className="text-base font-normal text-left">Vendor Company Name</label>
                <div className="w-full md:w-11/12 py-2 text-sm">{po.vendorID.vendorCompanyName}</div>
              </div>

              {
                (
                  userData.doc.isSuperAdmin ||
                  userData.doc.isAdmin
                )
                && (
                  <div className="flex flex-col space-y-3 w-full md:w-1/3">
                    <label className=" text-base font-normal text-left">Purchase Order Creator</label>
                    <select disabled defaultValue={po.purchaseOrderCreator._id} name="purchaseOrderCreator" className='border border-[#8E8EA1] w-full md:w-11/12 py-2 rounded-[40px] px-3 outline-none text-sm'>
                      <option value={""}>Select an employee</option>
                      {employeesList}
                    </select>
                  </div>
                )
              }
            </div>

            <div className='overflow-x-auto rounded-lg border'>
              <table>
                <thead>
                  <tr>
                    <th>Material</th>
                    <th>Demand</th>
                    <th>Quote</th>
                    <th>Rate</th>
                    <th>Quantity to order</th>
                  </tr>
                </thead>
                <tbody>
                  {poItemsList}
                </tbody>
              </table>
            </div>
            <div className='flex flex-row justify-end my-5'>
              Gross Amount: <span className='pl-1'>{grossTotal}</span>
            </div>

            <div className='flex flex-col gap-y-3 text-sm text-gray-900 font-normal text-left'>
              <div className='w-full p-2 border border-[#8E8EA1]'>
                MD says: <div className='p-2'>{po.mdComment ? po.mdComment : <i>No comments yet</i>}</div>
              </div>
              <div className='w-full p-2 border border-[#8E8EA1]'>
                COO says: <div className='p-2'>{po.cooComment ? po.cooComment : <i>No comments yet</i>}</div>
              </div>
              <div className='w-full p-2 border border-[#8E8EA1]'>
                Project Manager says: <div className='p-2'>{po.pmComment ? po.pmComment : <i>No comments yet</i>}</div>
              </div>
              <div className='w-full p-2 border border-[#8E8EA1]'>
                QS says: <div className='p-2'>{po.qsComment ? po.qsComment : <i>No comments yet</i>}</div>
              </div>
            </div>

            {
              (
                userData.doc.isSuperAdmin ||
                (userData.doc.isAdmin && userData.doc.managementRank === "md")
              ) && (
                <div className='flex flex-col gap-y-3 p-2 text-sm text-gray-900 font-normal text-left border border-[#8E8EA1]'>
                  <div className='w-full'>
                    Managing Director:
                  </div>
                  <div className='w-full'>
                    <input type="checkbox" name="mdConsent" value="accept" defaultChecked={po.mdConsent === "accept"} className='me-1' />
                    <span>Accept</span>
                  </div>
                  <div className='w-full'>
                    <div className='mb-2'>Comments: </div>
                    <textarea name="mdComment" className='w-full md:w-1/2 p-2 border outline-none' defaultValue={po.mdComment} placeholder='Please enter your comments here.'></textarea>
                  </div>
                </div>
              )
            }

            {
              (
                userData.doc.isSuperAdmin ||
                (userData.doc.isAdmin && userData.doc.managementRank === "coo")
              ) && (
                <div className='flex flex-col gap-y-3 p-2 text-sm text-gray-900 font-normal text-left border border-[#8E8EA1]'>
                  <div className='w-full'>
                    Chief Operations Officer:
                  </div>
                  <div className='w-full'>
                    <input type="checkbox" name="cooConsent" value="accept" defaultChecked={po.cooConsent === "accept"} className='me-1' />
                    <span>Accept</span>
                  </div>
                  <div className='w-full'>
                    <div className='mb-2'>Comments: </div>
                    <textarea name="cooComment" className='w-full md:w-1/2 p-2 border outline-none' defaultValue={po.cooComment} placeholder='Please enter your comments here.'></textarea>
                  </div>
                </div>
              )
            }

            {
              (
                userData.doc.isSuperAdmin ||
                userData.role.create.includes("projects")
              ) && (
                <div className='flex flex-col gap-y-3 p-2 text-sm text-gray-900 font-normal text-left border border-[#8E8EA1]'>
                  <div className='w-full'>
                    Project Manager:
                  </div>
                  <div className='w-full'>
                    <input type="checkbox" name="pmConsent" value="accept" defaultChecked={po.pmConsent === "accept"} className='me-1' />
                    <span>Accept</span>
                  </div>
                  <div className='w-full'>
                    <div className='mb-2'>Comments: </div>
                    <textarea name="pmComment" className='w-full md:w-1/2 p-2 border outline-none' defaultValue={po.pmComment} placeholder='Please enter your comments here.'></textarea>
                  </div>
                </div>
              )
            }

            {
              (
                userData.doc.isSuperAdmin ||
                userData.role.create.includes("projects")
              ) && (
                <div className='flex flex-col gap-y-3 p-2 text-sm text-gray-900 font-normal text-left border border-[#8E8EA1]'>
                  <div className='w-full'>
                    QS:
                  </div>
                  <div className='w-full'>
                    <input type="checkbox" name="qsConsent" value="accept" defaultChecked={po.qsConsent === "accept"} className='me-1' />
                    <span>Accept</span>
                  </div>
                  <div className='w-full'>
                    <div className='mb-2'>Comments: </div>
                    <textarea name="qsComment" className='w-full md:w-1/2 p-2 border outline-none' defaultValue={po.qsComment} placeholder='Please enter your comments here.'></textarea>
                  </div>
                </div>
              )
            }

            <div className='flex flex-row my-5'>
              <button disabled={isSubmitting} type="submit" id="submit" className='text-white bg-primary rounded-[40px] w-[299px] h-9'>
                {isSubmitting ? <ClipLoader size={17} color="#fff" /> : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  )
}
